// Must match backend app/jetton/constants.py JETTON_GROWTH_RATE
export const JETTON_GROWTH_RATE = 0.00006;
